import { Action, createReducer, on } from '@ngrx/store'
import { OnboardingState, initialOnboardingState } from '../state/onboarding.state'
import {
  save_entities_success,
  save_others_success,
  load_onboarding_success,
  save_company_success_action,
  loadScreenConfigsByCompanyGroupSuccess,
  saveScreenConfigSuccess,
  save_sop_settings_success,
  assign_employee_admins_success,
  resetCompany
} from '../action/onboarding.action'

export function onboardingReducer(state: OnboardingState, action: Action) {
  return _onboardingReducer(state, action)
}

const _onboardingReducer = createReducer(
  initialOnboardingState,

  // LOAD (Edit mode)
  on(load_onboarding_success, (state, data) => ({
    ...state,
    company: data.company,
    entities: data.entities,
    sopSettings: data.sopSettings,
    employees: data.employees,
    others: data.others,
    isEditMode: true
  })),

  on(save_company_success_action, (state, { company }) => ({
    ...state,
    company
  })),
  on(resetCompany, state => ({
    ...state,
    company: null
  })),
  // STEP 2
  on(save_entities_success, (state, { entities }) => ({
    ...state,
    entities
  })),

  // STEP 3
  on(save_sop_settings_success, state => ({
    ...state,
    sopSettings: { ...state.sopSettings } // just mark step complete, currently no response obj
  })),

  // STEP 4
  on(assign_employee_admins_success, state => ({
    ...state
  })),

  // STEP 5 - Screen Config
  on(loadScreenConfigsByCompanyGroupSuccess, (state, { configs }) => ({
    ...state,
    loading: false,
    screenConfigs: configs
  })),

  on(saveScreenConfigSuccess, (state, { config }) => ({
    ...state,
    saving: false,
    screenConfigs: [...state.screenConfigs.filter(c => c.type !== config.type), config]
  })),

  // STEP 6
  on(save_others_success, (state, { companyGroup }) => ({
    ...state,
    company: companyGroup
  }))
)
